export const FETCH_PRODUCTS = "fetchProducts";
export const RESET_PRODUCTS = "resetProducts";
export const EAGER_FETCH_PRODUCTS = "eagerFetchProducts";
export const FETCH_CATEGORIES = "fetchCategories";
export const NO_RESPONSE = "requestFailed";
export const FETCH_COMPARABLE_PRODUCTS = "fetchComparableProducts";
export const DOWNLOAD_PRODUCTS_EXCEL = "downloadProductsExcel";
export const FETCH_RECOMMENDED_PRODUCTS = "fetchRecommendedProducts";
export const DOWNLOAD_COMPARE_EXCEL = "downloadCompareExcel";
export const DOWNLOAD_RECOMMENDED_EXCEL = "downloadRecommendedExcel";
export const LOGIN_USER = "loginUser";
export const LOGOUT_USER = "logoutUser";
export const UPDATE_USER = "updateUser";
export const UPDATE_USER_SUBSCRIPTIONS = "updateUserSubscriptions";
export const REGISTER_USER = "registerUser";
export const APPROVE_USER = "approveUser";
export const SEND_SUPPORT_TICKET = "sendSupportTicket";
export const FORGOT_PASSWORD = "forgotPassword";
export const RESET_PASSWORD = "resetPassword";
export const EXPIRED_PASSWORD = "resetExpiredPassword";
export const FETCH_DOCUMENT_CATEGORIES = "fetchDocumentCategories";
export const FETCH_DOCUMENTS = "fetchDocuments";
export const DOWNLOAD_DOCUMENTS = "downloadDocuments";
export const DOWNLOAD_ALL_CUSTOMER_INFORMATION = "downloadAllCustomerInformation";
export const DOWNLOAD_TASKS_HISTORY = "downloadTasksHistory";
export const DOWNLOAD_USER_BEHAVIOR = "downloadUserBehavior";
export const DOWNLOAD_DOCUMENT_ACCESS = "downloadDocumentAccess";
export const FETCH_TASKS = "fetchTasks";
export const OPEN_MODAL = "openModal";
export const APPROVE_DOCUMENT = "approveDocument";
export const REJECT_DOCUMENT = "rejectDocument";
export const DELETE_USER_ACCOUNT = "deleteUserAccount";
export const SEND_MY_SUPPORT_TICKET = "sendMySupportTicket";
export const FETCH_MY_SUPPORT_CONTACT = "fetchMySupportContact";
export const FETCH_MY_SUPPORT_TOPICS = "fetchMySupportTopics";

// Generic actions
export const FINALIZE_ACTION = "finalizeAction";
